import axios from 'axios';
import { get } from 'lodash';
import versionObj from '../config/version.json';


const UI_VERSION = versionObj.HIVE_MARKETPLACE_VERSION;
if (!window.version) {
  window.version = { UI_VERSION };
  const originalVersion = window.version;
  try {
    Object.defineProperty(window, 'version', { value: originalVersion, writable: false });
  } catch (_) {} // eslint-disable-line
}


const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:9090'
  : 'https://api.crypto-shots.com';


// import authHeader from './authHeader';
export function client(endpoint, { method, body, contentType = 'application/json', ...customConfig } = {}) {
  const options = {
    url: `${API_URL}${endpoint}?chain=hive`,
    method,
    ...customConfig,
    data: body,
    headers: {
      'Content-Type': contentType,
      'X-FE-VERSION': `M_v${get(window, 'version.UI_VERSION')}`,
      // plus axios.defaults.headers.common.Authorization set with JWT token
    },
  }
  console.debug('-- Sending api request:', options);
  const response = axios(options);
  return response;
}

client.get = function(endpoint, customConfig = {}) {
  return client(endpoint, {...customConfig, method: 'GET' })
};

client.post = function(endpoint, body, customConfig = {}) {
  return client(endpoint, {...customConfig, method: 'POST', body })
};

client.postForm = function(endpoint, body, customConfig = {}) {
  return client(endpoint, { method: 'POST', body, contentType: false })
};

client.put = function(endpoint, body, customConfig = {}) {
  return client(endpoint, {...customConfig, method: 'PUT', body })
};

client.delete = function(endpoint, body, customConfig = {}) {
  return client(endpoint, {...customConfig, method: 'DELETE', body })
};
